import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Input, Field, Select } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const EditCategory = ({ category, categories, onClose, onSave, show }) => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const new_category = category || {};

    setData({
      description: new_category.description || '',
      guid: new_category.guid,
      mobile_app_guid: new_category.mobile_app_guid,
      name: new_category.name || '',
      order: new_category.order || 0,
      parent_category_guid: new_category.parent_category_guid || ''
    });
  }, [category]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];
    const required_fields = ['name'];

    required_fields.forEach(field => {
      if (!data[field]) {
        errors.push(field);
      }
    });

    setErrors(errors);

    if (!errors.length) {
      window.scrollTo(0, 0);

      Api.saveMobileAppResourceCategory(data.guid, data).then(() => {
        onSave();
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>
          {data.guid ? 'Save Changes' : 'Create Resource Category'}
        </Button>
      }
      onClose={onClose}
      show={show}
      title={data.guid ? 'Editing Resource Category' : 'New Resource Category'}
    >
      <Field label='Parent Category'>
        <Select
          onChange={handleInputChange.bind(null, 'parent_category_guid')}
          options={[{ value: '', label: 'Top Level' }].concat(
            categories.map(c => {
              return {
                value: c.guid,
                label: c.name
              };
            })
          )}
          required={true}
          value={data.parent_category_guid}
        />
      </Field>

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          value={data.name}
        />
      </Field>

      <Field label='Description'>
        <Input onChange={handleInputChange.bind(null, 'description')} value={data.description} />
      </Field>

      <Field label='Display Order'>
        <Input
          onChange={handleInputChange.bind(null, 'order')}
          step={1}
          type='number'
          value={data.order}
        />
      </Field>
    </Drawer>
  );
};

EditCategory.propTypes = {
  categories: PropTypes.array,
  category: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default EditCategory;
